import React from "react";
import CardWithBorder from "../../newComponent/NewCardsComp/CardWithBorder";
import { Box, Paper, Typography, Stack, Card } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TargetIcon from "@mui/icons-material/GpsFixed";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HomeIcon from "@mui/icons-material/Home";
import NotesIcon from "@mui/icons-material/StickyNote2";
import { MdOutlineTopic } from "react-icons/md";
import parse from "html-react-parser";
const SectionCard = ({ icon, title, value, color }) => {
  return (
    <Box mb={3}>
      {/* Title Row */}
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <Box color="orange">{icon}</Box>

        <Typography fontWeight={600} fontSize="16px" color="#4CAF50">
          {title}
        </Typography>
      </Stack>

      {/* Content Card */}
      <Card
        sx={{
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          borderLeft: "3px solid #4CAF50", // purple left border
          mb: 2,
          p: "15px",
        }}
      >
        <Typography color="text.secondary">{value || "-"}</Typography>
      </Card>
    </Box>
  );
};

export default function ViewMode({ currentLesson, activeDay, activeDayIndex }) {
  console.log("currentLesson.presentation_file_path", currentLesson);
  return (
    <>
      <CardWithBorder>
        <Typography variant="h6" mb={2}>
          Day {activeDay?.day_number || activeDayIndex + 1} Lesson Plan
        </Typography>

        <SectionCard
          icon={<MdOutlineTopic size={20} />}
          title="Topic"
          value={currentLesson?.topic}
          color="#FF6B6B"
        />
        <SectionCard
          icon={<TargetIcon fontSize="small" />}
          title="Objective"
          value={currentLesson?.objective}
          color="#7B61FF"
        />

        <SectionCard
          icon={<MenuBookIcon fontSize="small" />}
          title="Content"
          value={currentLesson?.content && parse(currentLesson?.content)}
          color="#5B8DEF"
        />

        <SectionCard
          icon={<ListAltIcon fontSize="small" />}
          title="Activities"
          value={currentLesson?.activity}
          color="#FF9F43"
        />

        {/* <SectionCard
        icon={<HomeIcon fontSize="small" />}
        title="Homework"
        value={currentLesson?.homework}
        color="#28C76F"
      /> */}

        <SectionCard
          icon={<NotesIcon fontSize="small" />}
          title="Notes"
          value={currentLesson?.remarks}
          color="#EA5455"
        />

        {/* Presentation */}

        {currentLesson.presentation_files?.length > 0 && (
          <>
            <Typography fontWeight={600} fontSize="16px" color="#4CAF50" mt={2}>
              Presentation
            </Typography>

            {currentLesson?.presentation_files.map((file, index) => {
              const fileName = file?.original_filename || file?.name;
              const filePath = file?.secure_url || URL.createObjectURL(file);

              return (
                <Paper
                  key={index}
                  variant="outlined"
                  sx={{
                    mt: 1,
                    p: 1.5,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    bgcolor: "#F9FCFA",
                  }}
                >
                  <InsertDriveFileIcon color="error" />

                  <Typography
                    onClick={() => {
                      window.open(filePath, "_blank");
                    }}
                    sx={{
                      color: "#1976D2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: 500,
                    }}
                  >
                    {fileName}
                  </Typography>
                </Paper>
              );
            })}
          </>
        )}

        {currentLesson.study_material?.length > 0 && (
          <>
            <Typography fontWeight={600} fontSize="16px" color="#4CAF50" mt={2}>
              Study Material
            </Typography>

            {currentLesson.study_material.map((file, index) => {
              const fileName = file?.original_filename || file?.name;
              const filePath = file?.secure_url || URL.createObjectURL(file);

              return (
                <Paper
                  key={index}
                  variant="outlined"
                  sx={{
                    mt: 1,
                    p: 1.5,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    bgcolor: "#F9FCFA",
                  }}
                >
                  <InsertDriveFileIcon color="error" />

                  <Typography
                    onClick={() => {
                      window.open(filePath, "_blank");
                    }}
                    sx={{
                      color: "#1976D2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: 500,
                    }}
                  >
                    {fileName}
                  </Typography>
                </Paper>
              );
            })}
          </>
        )}
      </CardWithBorder>
    </>
  );
}
